import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { WHATSAPP_LINK } from "../lib/constants";

export const FooterCTA = () => {
    return (
        <section
            data-testid="footer-cta-section"
            className="relative py-28 sm:py-36 bg-[#050505] border-t border-white/5 overflow-hidden"
        >
            <div className="absolute inset-0 grid-pattern radial-fade opacity-60 pointer-events-none" />
            <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-gold/[0.07] blur-[140px] pointer-events-none" />

            <div className="relative max-w-6xl mx-auto px-6 md:px-12 text-center">
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.7 }}
                    className="font-poppins font-bold tracking-tight text-white text-4xl sm:text-6xl lg:text-7xl leading-[1.05]"
                    data-testid="footer-cta-headline"
                >
                    Let's Build Your <br />
                    <span className="gold-gradient-text">Brand Today.</span>
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="mt-6 font-inter text-base sm:text-lg text-zinc-400 max-w-xl mx-auto"
                >
                    A 15‑minute call is all it takes to know if we're the right fit. No
                    obligations, just clear next steps.
                </motion.p>

                <motion.a
                    href={WHATSAPP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    data-testid="footer-cta-whatsapp"
                    className="group mt-10 inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1fbb59] text-white font-medium font-inter px-8 py-4 rounded-full transition-all duration-200 shadow-[0_10px_40px_rgba(37,211,102,0.25)]"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.296-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.464 3.488" />
                    </svg>
                    Chat on WhatsApp
                    <ArrowRight
                        size={18}
                        className="transition-transform group-hover:translate-x-1"
                    />
                </motion.a>
            </div>
        </section>
    );
};

export default FooterCTA;
